var map = {
	"./ava_search_ikon.svg": 2003,
	"./galeria_search_ikon.svg": 9210,
	"./jamh_search_ikon.svg": 7973,
	"./kbmo_search_ikon.svg": 6066,
	"./ktkh_search_ikon.svg": 4801,
	"./pmh_search_ikon.svg": 6590,
	"./szimh_search_ikon.svg": 7630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 921;